(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manahveda-product"]) return;
  try {
    
(function () {
  const mainImage = document.getElementById('MvProductMainImage');
  const thumbs = document.querySelectorAll('#MvProductThumbs .mv-product__thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
      }
      thumbs.forEach(function (t) {
        t.classList.remove('mv-product__thumb--active');
      });
      thumb.classList.add('mv-product__thumb--active');
    });
  });

  const variantInput = document.getElementById('MvVariantId');
  const priceEl = document.getElementById('MvProductPrice');
  const variantButtons = document.querySelectorAll('#MvVariantOptions .mv-product__variant-option');

  variantButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      variantButtons.forEach(function (b) {
        b.classList.remove('mv-product__variant-option--active');
      });
      button.classList.add('mv-product__variant-option--active');

      if (variantInput) {
        variantInput.value = button.dataset.variantId;
      }
      if (priceEl && button.dataset.variantPrice) {
        priceEl.textContent = button.dataset.variantPrice;
      }
      if (mainImage && button.dataset.variantImage) {
        mainImage.src = button.dataset.variantImage;
        mainImage.removeAttribute('srcset');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.variantId);
      window.history.replaceState({}, '', url.toString());
    });
  });

  const qtyInput = document.getElementById('MvQtyInput');
  const qtyMinus = document.getElementById('MvQtyMinus');
  const qtyPlus = document.getElementById('MvQtyPlus');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      const current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, current - 1);
    });
  }

  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      const current = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = current + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
